export default __webpack_public_path__ + "static/media/Comp 2_00014.b3e2dbe0.png";